export default class ClientCompanyTypeModel {
    ClientLeadId: number;
    ClientName: string;
    MobileNumber: string;
    EmailId: string;
    Description: string;
    ClientCompanyTypeNames: string;
    ClientCompanyTypeIds: string;
}
